import {Component, OnInit} from '@angular/core';
import {Toast} from 'app/shared/toast/toast';
import {IdexService} from 'app/idex.service';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';

declare let $: any;
let message;

@Component({
   selector: 'app-new-contact',
   templateUrl: './new-contact.component.html',
   styleUrls: ['./new-contact.component.css']
})
export class NewContactComponent implements OnInit {
   backButton;
   viewMode = false;
   isAddContact = true;
   contIdvalue = '';
   contNamevalue = '';
   contEmailvalue = '';
   error_email = false;
   errorMessage: string;
   requireInputMessage: string;

   constructor(public toast: Toast,
               public service: IdexService,
               public translate: TranslateService,
               private dialogRef: MatDialogRef<NewContactComponent>) {
   }

   ngOnInit() {
      if (!this.viewMode) {
         this.translate.get('cancel').subscribe((msg) => {
            this.backButton = msg;
         });
      } else {
         this.translate.get('signOff.close').subscribe((msg) => {
            this.backButton = msg;
         });
      }
      this.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });


      $('#form input[type=text]').on('change invalid', function () {
         const textfield = $(this).get(0);

         textfield.setCustomValidity('');
         if (!textfield.validity.valid) {
            textfield.setCustomValidity(message);
         }
      });
   }

   onkeyup(item) {
      const reg = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      if (item.value.length === 0) {
         this.error_email = false;
         return;
      } else if (!reg.test(item.value)) {
         this.error_email = true;
         return;
      } else {
         this.error_email = false;
      }
   }

   InvalidMsg(fullName) {
      if (fullName.value === '') {
         fullName.setCustomValidity('Required email address');
      } else {
         fullName.setCustomValidity('');
      }

      return true;
   }

   addContact(id: any, fullName: any, email: any) {
      if (!this.error_email) {
         const contactId = id.value;
         const contactName = fullName.value.trim();
         const contactEmail = email.value;
         if (/[<|>\\\/:?*"%^{}[\]]/g.test(contactName)) {
            this.translate.get('alert.create_folder_errors_full').subscribe(s => {
               this.errorMessage = s;
            });
            return;
         } else {
            this.errorMessage = ' ';
         }
         if (contactId === '') {
            this.service.addContact(contactName, contactEmail)
               .subscribe((response) => {
                  this.dialogRef.close(true);
                  this.toast.success(response);
               });
         } else {
            this.service.updateContact(contactId, contactName, contactEmail)
               .subscribe((response) => {
                  this.dialogRef.close(true);
                  this.toast.success(response);
               });
         }
      }
   }
}
